import React from 'react';

export default props => (
  <svg {...props}>
    {props.children}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.7072 5.70706L8.70718 17.7071C8.31666 18.0976 7.68349 18.0976 7.29297 17.7071L1.29297 11.7071L2.70718 10.2928L8.00008 15.5857L19.293 4.29285L20.7072 5.70706Z"
    />
  </svg>
);
